import { c as _c } from "react/compiler-runtime";
import { QueryParams } from "@router/route-params";
import { useAppDispatch } from "@store/store-helper";
import { setIsHideMigratedWorkspacesEnabled } from "@store/ui/ui-slice";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * Hook to get the workspace params and set them on the UI.
 */
export function useWorkspaceParams() {
  const $ = _c(6);
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = searchParams.get(QueryParams.hideMigratedWorkspaces);
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const hideMigratedWorkspaces = t0;
  let t1;
  let t2;
  if ($[2] !== dispatch || $[3] !== hideMigratedWorkspaces) {
    t1 = () => {
      if (!hideMigratedWorkspaces) {
        return;
      }
      dispatch(setIsHideMigratedWorkspacesEnabled(hideMigratedWorkspaces.toLowerCase() === "true"));
    };
    t2 = [dispatch, hideMigratedWorkspaces];
    $[2] = dispatch;
    $[3] = hideMigratedWorkspaces;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
}